(() => {
  const initCartDrawer = () => {
    const drawer = document.getElementById("sxs-cart-drawer");

    if (!drawer) return;

    const body = document.body;
    const closeControl = drawer.querySelector(".widget-close");
    const status = drawer.querySelector(".sxs-cart-drawer__status");
    const content = drawer.querySelector(".widget_shopping_cart_content");
    const openerSelector = ".cart-widget-opener a";
    let returnFocusTo = null;
    let wasOpen = false;
    let announceTimer = null;
    let addedAnnouncement = null;

    drawer.addEventListener("sxs:cart-added", (event) => {
      addedAnnouncement = event.detail.message;
    });

    const getFocusableElements = () =>
      Array.from(
        drawer.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
      ).filter((element) => element.getClientRects().length > 0);

    const setOpenerAttributes = (isOpen) => {
      document.querySelectorAll(openerSelector).forEach((opener) => {
        opener.setAttribute("aria-controls", drawer.id);
        opener.setAttribute("aria-expanded", String(isOpen));
        opener.setAttribute("aria-haspopup", "dialog");
      });
    };

    const syncDrawerState = () => {
      const isOpen = body.classList.contains("basel-cart-opened");

      drawer.setAttribute("aria-hidden", String(!isOpen));
      setOpenerAttributes(isOpen);

      if (isOpen && !wasOpen) {
        window.requestAnimationFrame(() => {
          if (!document.querySelector(".sxs-matching-modal[open]")) closeControl?.focus();
        });
      }

      if (!isOpen && wasOpen && returnFocusTo?.isConnected) {
        window.requestAnimationFrame(() => {
          if (!document.querySelector(".sxs-matching-modal[open]")) returnFocusTo.focus();
        });
      }

      wasOpen = isOpen;
    };

    document.addEventListener(
      "click",
      (event) => {
        const opener = event.target instanceof Element ? event.target.closest(openerSelector) : null;

        if (opener) returnFocusTo = opener;
      },
      true
    );

    drawer.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        event.preventDefault();
        closeControl?.click();
        return;
      }

      if (event.key !== "Tab") return;

      const focusableElements = getFocusableElements();
      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];

      if (!firstElement || !lastElement) {
        event.preventDefault();
        closeControl?.focus();
        return;
      }

      if (event.shiftKey && document.activeElement === firstElement) {
        event.preventDefault();
        lastElement.focus();
      } else if (!event.shiftKey && document.activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus();
      }
    });

    new MutationObserver(syncDrawerState).observe(body, {
      attributeFilter: ["class"],
      attributes: true,
    });

    if (content && status) {
      new MutationObserver(() => {
        window.clearTimeout(announceTimer);
        announceTimer = window.setTimeout(() => {
          status.textContent = "";
          window.requestAnimationFrame(() => {
            status.textContent = addedAnnouncement || drawer.dataset.updatedMessage || "";
            addedAnnouncement = null;
          });
        }, 250);
      }).observe(content, { childList: true, subtree: true });
    }

    syncDrawerState();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCartDrawer, { once: true });
  } else {
    initCartDrawer();
  }
})();
